import '@babel/polyfill';
if (!('fetch' in window)) {
  import('whatwg-fetch');
}
